import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=88ba039c&scoped=true&"
import script from "./CustomDialog.vue?vue&type=script&lang=js&"
export * from "./CustomDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomDialog.vue?vue&type=style&index=0&id=88ba039c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ba039c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardActions,VCardTitle,VDialog,VIcon,VSkeletonLoader})
